<template>
  <EmptySection ref="empty-section" />
</template>

<script>
import EmptySection from '@/components/content/education/courses/CourseBookEmptySection.vue'

export default {
  name: 'CourseBookEmptySection',
  components: { EmptySection },
  beforeRouteUpdate(to, from, next) {
    if (this.$refs['empty-section']) {
      this.$refs['empty-section'].onBeforeRouteUpdate(to, from, next)
    }
  },
  beforeRouteLeave(to, from, next) {
    if (this.$refs['empty-section']) {
      this.$refs['empty-section'].onBeforeRouteLeave(to, from, next)
    }
  },
  beforeDestroy() {
    if (this.$refs['empty-section']) {
      this.$refs['empty-section'].onBeforeDestroy()
    }
  }
}
</script>

<style scoped>

</style>
